module.exports = __webpack_public_path__ + "img/streamnative_logo.8284ad3d.png";